import React, { useState, useEffect } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {orderTotal} from '../../redux/selectors/order';
import {isMobileAndTablet, isMobileApp} from '../../helpers/common';

import './GreenBillPage.scss';
import { getImageUrl } from '../../api/iposApi';
import OrderInfoItem from '../components/OrderInfoItem';
import FormattedPrice from '../../components/FormattedPrice';
import {withTranslation} from 'react-i18next';
import UtensilsInfoItem from '../components/UtensilsInfoItem';
import IPosModal from '../../IPosModal';
import { getGreenBillUrl } from '../../api/iposApi';
import { useParams } from 'react-router-dom';

const GreenBillPage = ({ t, orderItems, totalAmount, orderInfo, clientInfo, branchInfo }) => {
  const isMobile = isMobileAndTablet();
  const { branchId, orderId } = useParams();

  const openGreenBillPdf = () => {
    IPosModal.alert({
      title: '',
      message: t('order_info.green_bill_pass_notification'),
      okButtonText: t('buttons.ok'),
      onOk: () => {
        window.location = getGreenBillUrl(orderId);
      }
    });
  };

  return (
    <div className={ 'green_bill_page' }>
      <img className="img-logo" src={getImageUrl(branchInfo.LogoImageName)} alt="iPos Web Delivery"/>
      <div className="container">
        <div className={ 'row' }>
          <div className="col-md-12 place-name">
            <div className={ '' }>{ branchInfo.PlaseName }</div>
          </div>
        </div>
        <div className={ 'row' }>
          <div className="col-md-12 order-info">
            <div className={ 'order-id' }>{ t('order_info.green_bill_transaction') } {orderInfo.order_id}</div>
          </div>
        </div>

        <div className={ 'row' }>
          <div className="col-md-12 order-summary">
            <div className={ 'title' }>{ t('order_info.green_bill_order_details') }</div>
            <div className={ 'order-items-list' }>
              {
                orderItems.length > 0 && orderItems.map(item => (

                  item.menuItemType === 'DISHES_ITEM'
                    ? <UtensilsInfoItem item={ item } />
                    : <OrderInfoItem item={ item } shortInfo branchInfo={ branchInfo }/>
                ))
              }
              <div className={ 'order-item-info totals' }>
                <div className={ 'info-block' }>
                  <div className={ 'parent-item-info' }>
                    <div className={ 'item-info-block' }>
                      <div className={ 'item-name' }>{ t('order_info.total') }</div>
                    </div>

                    <div className={ 'item-quantity-info-block' }>
                      <div className={ 'item-quantity-info' }>&nbsp;</div>
                    </div>

                    <div className={ 'item-price-block' }>
                      <div className={ 'item-price' }>
                        <b><FormattedPrice price={ totalAmount } /></b>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className={ 'order-green-bill-block' }>
                <div
                  className={ 'btn blue-btn' }
                  onClick={ openGreenBillPdf }
                >
                  { t('order_info.green_bill_btn') }
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={ 'row' }>
          <div className="col-md-12 order-footer">
            {/*<div className={'greetings'}>{ t('order_info.thank_you_ipos') }</div>*/}

            <div className={ 'copyright' }>
              powered by <b> iPOS</b>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    branchInfo,
    orderItems,
    orderInfo,
    clientInfo
  } = state;

  return {
    branchInfo,
    totalAmount: orderTotal(state),
    orderItems,
    orderInfo,
    clientInfo
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {

    },
    dispatch,
  );
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(GreenBillPage));
